import {useFormContext} from "react-hook-form";

type Option = {
    [key: string]: any;
};

type InputSelectFormProps = {
    name: string;
    label: string;
    options: Option[];
    optionsText: string;
    optionsValue: string;
    required?: boolean;
    publicField?: boolean;
    help?: string;
};

export default function InputSelectForm({
                                            name,
                                            label,
                                            options,
                                            optionsText,
                                            optionsValue,
                                            required = false,
                                            publicField = false,
                                            help,
                                        }: InputSelectFormProps) {
    const {
        register,
        formState: {errors},
    } = useFormContext();

    const fieldError = errors[name]?.message as string | undefined;

    return (
        <div className="input_select">
            <label htmlFor={name}>
                <span>{label}</span>
                {required && (
                    <abbr className="required" title="required">
                        <em className="icon-sun-3"></em>
                    </abbr>
                )}
                {publicField && (
                    <abbr className="public" title="public">
                        <em className="icon-unhide"></em>
                    </abbr>
                )}
                <select
                    id={name}
                    className={`select-css ${fieldError ? "error" : ""}`}
                    {...register(name, {required})}
                >
                    <option value="">--</option>
                    {options.map((option) => (
                        <option key={option[optionsValue]} value={option[optionsValue]}>
                            {option[optionsText]}
                        </option>
                    ))}
                </select>
                <span className="error" style={{display: fieldError ? "block" : "none"}}></span>
            </label>


            <span className={`block_help${fieldError ? ' block_help_error' : ''}`}>
                {fieldError ?? help}
            </span>

        </div>
    );
}

// <div className="input_select">
//     <label data-bind="attr: { 'for' : name }">
//         <span data-bind="text: label">Billing period</span>
//         <select className="select-css"
//                 data-bind="options: options, optionsText: options_text, optionsValue: options_value, attr: { 'id' : name, 'name' : name, 'required' : required }, value: value"
//                 name="" title="">
//             <option value="371">Billing period 37</option>
//             <option value="357">Billing period 4</option>
//             <option value="389">Billing period 8</option>
//             <option value="375">Billing period 9</option>
//             <option value="301">Data report 2023</option>
//             <option value="10">Druhe vytvorene cez appku</option>
//             <option value="282">evka test</option>
//             <option value="281">Leto 2023</option>
//             <option value="274">Release 2.6.7.</option>
//             <option value="270">TEST 2.6.6.c</option>
//             <option value="279">Test aktivnosti 2</option>
//             <option value="242">Test Martin</option>
//             <option value="9">Vytvorene cez appku</option>
//             <option value="283">Zuzanka testuje</option>
//             <option value="243">Zuzu</option>
//         </select><span className="error" style="display: none;"></span>
//     </label>
//     <span className="block_help" data-bind="text: help"></span>
// </div>
